import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { marcarCanceladoControlePragaDoenca } from '../service';

import {
  MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA,
  MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_PENDING,
  MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_SUCCESS,
  MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_FAILURE,
  NEW_FILTER_CONTROLE_PRAGA_DOENCA,
} from '../actionTypes';

import { AlertError, AlertSuccess } from '@components/common/AlertToast';

function* sagaMarcarCanceladoControlePragaDoenca(action) {
  yield put({ type: MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_PENDING, id: action.id });

  try {
    yield call(marcarCanceladoControlePragaDoenca, action.id);

    yield put({ type: MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_SUCCESS, id: action.id });

    AlertSuccess('Controle marcado como cancelado com sucesso!');

    // Recarrega a listagem para atualizar o status
    yield put({ type: NEW_FILTER_CONTROLE_PRAGA_DOENCA });

  } catch (error) {
    console.log(error);
    yield put({ type: MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA_FAILURE });
    AlertError('Falha ao marcar como cancelado! Tente novamente...');
  }
}

export default function* watchMarcarCanceladoControlePragaDoenca() {
  yield takeLatest(MARCAR_CANCELADO_CONTROLE_PRAGA_DOENCA, sagaMarcarCanceladoControlePragaDoenca);
}
